import React from "react";
import { Remarkable } from "remarkable";
import { LazyLoadImage } from "react-lazy-load-image-component";

const markdown = new Remarkable();

const VisualStory = ({ data }) => {
  const { title, content, image, textImage } = data;
  const {
    url,
    alternativeText,
    formats: { medium }
  } = image;
  return (
    <div className={`visualStory story-${content.index} ${textImage ? "switch" : ""}`}>
      <div className="image">
        <LazyLoadImage alt={alternativeText} src={medium?.url || url} effect="blur" />
      </div>
      <div className="text">
        <div className="title">
          <h3>{title}</h3>
        </div>
        <div className="paragraph" dangerouslySetInnerHTML={{ __html: markdown.render(content) }} />
      </div>
    </div>
  );
};

export default VisualStory;
